export const pallete = {
    black: '#333333',
    transparentGray: 'rgba(50, 50, 50, 0.3)',
    transparentWhite: 'rgba(255, 255, 255, 0.3)',
    white: '#ffffff',
    liteBlue: '#85b1c7',
    darkBlue: '#607d8b',
    orange: '#ff5722',
    red: '#d53402',
}

export default {
    coloredHeaders: pallete.darkBlue,
    liteHeader: pallete.liteBlue,
    text: pallete.darkBlue,
    invertedText: pallete.white,
    boxShadow: pallete.transparentGray,
    textShadow: pallete.black,
    borderColor: pallete.black,
    actionButton: pallete.red,
    projectTitle: pallete.red,
}



// WEBPACK FOOTER //
// ./src/colors.js